import React from 'react'

import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import Header from '../inc/Header';
import Map from './Map';
import petplazzashop from "../images/pet_plazza.jpg";


function Outlet() {
    return (
        <div>
            <Header />
            <br />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="maroon" />

            <div className="petprescriptionupload">
                <div className="album py-1">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Outlet</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <br />
                     <div className="album py-0">
                <div className="container">
            <h1 className='mb-0'>Pet Plazaa Krishnagar – Your Trusted <b style={{color:"#CC000A"}}>Pet Care</b> Destination</h1>
            <p><small>we pride ourselves on providing high-quality pet care products and services across three convenient locations: <b style={{color:"#CC000A"}}>Krishnagar, Chapra, and Municipality More</b>.</small></p>
            </div>
            </div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">


                        <div className="col-md-6 mt-3">
                            <div className="card">
                                <h4 className='btn-grad85'><svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                                    <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                    <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                </svg> PET PLAZZA KRISHNAGAR</h4>
                                {/* <img src="..." className="card-img-top" alt="..." /> */}
                                <div className="card-body">
                                    <h5 className="card-title mb-2">PET PLAZZA KRISHNAGAR</h5>
                                    <p className="card-text mb-0">Opp Maharashtra Bank , Near Sadar More Traffic Signal, </p>
                                    <p>Krishnanagar, Pin- 741101, Dist-Nadia, WB, India</p>
                                    <a href="tel: 8927119740" className="callbutton">Call: 8927119740</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-3">
                            <div className="card">
                                <h4 className='btn-grad85'><svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                                    <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                    <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                </svg> PET PLAZZA CHAPRA</h4>
                                {/* <img src="..." className="card-img-top" alt="..." /> */}
                                <div className="card-body">
                                    <h5 className="card-title mb-2"> PET PLAZZA CHAPRA</h5>
                                    <p className="card-text mb-0">Near Chapra Police Station, Chapra </p>
                                    <p>Dist-Nadia, WB, India</p>
                                    <a href="tel: 8927119640" className="callbutton">Call: 8927119640</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-3">
                            <div className="card">
                                <h4 className='btn-grad85'><svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                                    <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                    <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                </svg> PET PLAZZA MUNICIPILATY MORE</h4>
                                <img src={petplazzashop} className="card-img-top" alt="petplazzashop"/>
                                <div className="card-body">
                                    <h5 className="card-title mb-2"> Pet Plazza Vet Clinic & Grooming parlour </h5>
                                    <p className="card-text mb-0">2nd Floor ,Shop No 25 
Opp H.P Petrol Pump, Near Municipality More
 </p>
                                    <p>Krishnanagar, Dist-Nadia, WB, India</p>
                                    <Map/>
                                    <a href="tel: 8927119640" className="callbutton">Call: 8927119640</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <br />
        </div>
    )
}

export default Outlet